<img
  [src]="url()"
  alt=""
  style="width: 100%; height: 100%; user-select: none"
  [style.object-fit]="fit()"
  [style.background]="color()"
  (dragstart)="(false)"
/>
